<template>
</template>

<script>
var $ = require('jquery')
const {PDFDocument} = require('pdf-lib');

(function (API) {
  API.textAlign = function (txt, options, x, y, opt) {
    options = options || {}
    // Use the options align property to specify desired text alignment
    // Param x will be ignored if desired text alignment is 'center'.
    // Usage of options can easily extend the function to apply different text
    // styles and sizes

    // Get current font size
    var fontSize = this.internal.getFontSize()

    // Get page width
    var pageWidth = this.internal.pageSize.width

    // Get the actual text's width
    // You multiply the unit width of your string by your font size and divide
    // by the internal scale factor. The division is necessary
    // for the case where you use units other than 'pt' in the constructor
    // of jsPDF.

    var txtWidth = this.getStringUnitWidth(txt) * fontSize / this.internal.scaleFactor

    if (options.align === 'center') {

      // Calculate text's x coordinate
      x = (pageWidth - txtWidth) / 2

    } else if (options.align === 'centerAtX') { // center on X value

      x = x - (txtWidth / 2)

    } else if (options.align === 'right') {

      x = x - txtWidth
    }

    // Draw text at x,y
    if (opt) {
      this.text(txt, x, y, opt)
    } else {
      this.text(txt, x, y)
    }
  }
  /*
    API.textWidth = function(txt) {
      var fontSize = this.internal.getFontSize();
        return this.getStringUnitWidth(txt)*fontSize / this.internal.scaleFactor;
    };
*/

  API.getLineHeight = function (txt) {
    return this.internal.getLineHeight()
  }

})(window.jspdf.jsPDF.API)


export default {
  data: function () {
    return {}
  },
  props: {
    mainPdfData: {
      type: Object,
      required: true,
    }
  },
  mounted: function () {
    let th = this
    // console.log(this.mainPdfData.pdf_data_ready, 'this.mainPdfData.pdf_data_ready'); // false
  },
  watch: {
    'mainPdfData.pdf_data_ready': async function (val) {
      let th = this
      if (val) {
        await this.createPDF()
      }
    },
  },
  methods: {

    px2mm: function (pixel) {
      // px to inches
      var inches = pixel / 72
      return inches * 25.4
    },

    mm2px: function (millimeters) {
      // mm to inches
      var inches = millimeters / 25.4
      return inches * 72
    },

    // function to calculate and check img sizes
    imgSizes: function (img_w, img_h, img_mm_w) {
      let th = this
      /*
      img_w and img_h represent the original image size, in pixel
      img_mm_w is the desidered rendered image size, in millimeters
      */

      if (img_mm_w > this.mainPdfData.content_width) { // this should be never used...
        img_mm_w = this.mainPdfData.content_width
      }

      if (this.mm2px(img_mm_w) > img_w) {
        throw 'The `img_mm_w` parameter is too big'
      }

      var img_mm_h = Math.round((this.px2mm(img_h) * img_mm_w) / this.px2mm(img_w))

      return {
        w: img_mm_w,
        h: img_mm_h,
        centered_x: (this.mainPdfData.page_width - img_mm_w) / 2,
        left: 10
      }
    },

    downscaleImage(base64, maxWidth) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = function () {
          const scaleFactor = maxWidth / img.width
          const canvas = document.createElement('canvas')
          canvas.width = maxWidth
          canvas.height = img.height * scaleFactor

          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          const downscaledBase64 = canvas.toDataURL('image/png', 0.8)
          resolve(downscaledBase64)
        }
        img.src = base64
      })
    },


    createPDF: async function (update_preview) {
      const th = this
      console.log('create pdf')

      let _y, _x, // drawing coord
        lineHeight,

        refly_title_size = 24,
        size1 = 12,
        paragraph_size = 10,
        paragraph_color = '#2b57a4',
        paragraph_weigth = 'normal',
        lh_factor = 1.4,
        primary = '#0D306E',
        black = 0,

        // form data
        logo_subtitle = th.mainPdfData.logo_subtitle,
        refly_title = th.mainPdfData.refly_title,

        full_name = th.mainPdfData.full_name,
        full_name_label = th.mainPdfData.full_name_label,

        booking_reference_numb = th.mainPdfData.booking_reference_numb,
        booking_reference_title = th.mainPdfData.booking_reference_title,

        full_address = th.mainPdfData.full_address,
        full_address_title = th.mainPdfData.full_address_title,

        paragraph1 = th.mainPdfData.paragraph1,
        paragraph2 = th.mainPdfData.paragraph2,
        paragraph3 = th.mainPdfData.paragraph3,
        paragraph4 = th.mainPdfData.paragraph4,
        paragraph5 = th.mainPdfData.paragraph5,

        list = th.mainPdfData.list,

        date = th.mainPdfData.date,

        sing_title = th.mainPdfData.sing_title,
        date_title = th.mainPdfData.date_title,

        pdf = new window.jspdf.jsPDF('p', 'mm', th.mainPdfData.page_size)

      _y = th.mainPdfData.page_margin // vertical starting point

      // Optional - set properties of the document
      // pdf.setProperties({
      //   title   : REFLY,
      //   subject : this.mainPdfData.footer_content,
      //   author  : 'me',
      //   creator : 'WPM'
      // });

      // logo
      const compressedLogo = await th.downscaleImage(th.mainPdfData.agency_logo.src, 200)
      const logo_sizes = th.imgSizes(th.mainPdfData.agency_logo.w, th.mainPdfData.agency_logo.h, 40)
      pdf.addImage(compressedLogo, 'PNG', logo_sizes.left, _y, logo_sizes.w, logo_sizes.h)

      // fonts initializing
      pdf.setFont('helvetica', 'normal', 'bold')
      // console.log(pdf.getFontList(), 'sPDF.getFontList()');
      pdf.setTextColor(primary)

      // logo subtitle
      pdf.setFontSize(9)
      lineHeight = th.px2mm(pdf.getLineHeight(logo_subtitle))
      _y += (logo_sizes.h + 1 + lineHeight)
      pdf.textAlign(logo_subtitle, {align: 'left'}, th.mainPdfData.page_margin, _y)
      _y += th.mainPdfData.vspace


      // main title
      pdf.setFont('helvetica', 'normal', 'normal')
      pdf.setFontSize(refly_title_size)
      lineHeight = th.px2mm(pdf.getLineHeight(refly_title))
      _y += (th.mainPdfData.vspace + lineHeight)
      pdf.textAlign(refly_title, {align: 'left'}, th.mainPdfData.page_margin, _y)
      _y += th.mainPdfData.vspace


      // full name
      pdf.setFont('helvetica', 'normal', 'bold')
      pdf.setFontSize(size1)
      lineHeight = th.px2mm(pdf.getLineHeight(full_name))
      _y += (th.mainPdfData.vspace + lineHeight)
      pdf.textAlign(full_name, {align: 'left'}, this.mainPdfData.page_margin, _y)

      // booking reference name
      pdf.setFontSize(size1)
      pdf.textAlign(booking_reference_numb, {align: 'left'}, th.mainPdfData.x_half, _y)

      _y += th.mainPdfData.vspace


      // full name label
      pdf.setFont('helvetica', 'normal', 'normal')
      pdf.setFontSize(size1)
      lineHeight = th.px2mm(pdf.getLineHeight(full_name_label))
      _y += (lineHeight)
      pdf.textAlign(full_name_label, {align: 'left'}, th.mainPdfData.page_margin, _y)

      // booking reference label
      pdf.setFontSize(size1)
      pdf.textAlign(booking_reference_title, {align: 'left'}, th.mainPdfData.x_half, _y)

      _y += (th.mainPdfData.vspace - 2)

      // line
      pdf.setDrawColor(primary)
      pdf.line(th.mainPdfData.page_margin, _y, (th.mainPdfData.page_width - th.mainPdfData.page_margin), _y)
      _y += th.mainPdfData.vspace


      // full address
      pdf.setFont('helvetica', 'normal', 'bold')
      pdf.setFontSize(size1)
      lineHeight = th.px2mm(pdf.getLineHeight(full_address))
      _y += (th.mainPdfData.vspace + lineHeight)
      pdf.textAlign(full_address, {align: 'left'}, th.mainPdfData.page_margin, _y)

      _y += th.mainPdfData.vspace

      // full address label
      pdf.setFont('helvetica', 'normal', 'normal')
      pdf.setFontSize(size1)
      lineHeight = th.px2mm(pdf.getLineHeight(full_address_title))
      _y += (lineHeight)
      pdf.textAlign(full_address_title, {align: 'left'}, th.mainPdfData.page_margin, _y)

      _y += (th.mainPdfData.vspace - 2)
      // line
      pdf.setDrawColor(primary)
      pdf.line(th.mainPdfData.page_margin, _y, (th.mainPdfData.page_width - th.mainPdfData.page_margin), _y)

      _y += th.mainPdfData.vspace

      // paragraph
      pdf.setFont('helvetica', 'normal', paragraph_weigth)
      pdf.setLineHeightFactor(lh_factor)
      pdf.setTextColor(paragraph_color)
      pdf.setFontSize(paragraph_size)
      lineHeight = th.px2mm(pdf.getLineHeight(paragraph1))
      _y += (th.mainPdfData.vspace + lineHeight)
      pdf.textAlign(paragraph1, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(paragraph1).h * lh_factor * 6 + th.mainPdfData.vspace)

      pdf.textAlign(paragraph2, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(paragraph2).h * lh_factor * 2 + th.mainPdfData.vspace)

      pdf.textAlign(paragraph3, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(paragraph3).h * lh_factor * 2 + th.mainPdfData.vspace)

      pdf.textAlign(paragraph4, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(paragraph4).h * lh_factor * 1 + th.mainPdfData.vspace)

      pdf.textAlign(paragraph5, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(paragraph5).h * lh_factor * 3 + th.mainPdfData.vspace)


      pdf.textAlign(list, {align: 'left'}, th.mainPdfData.page_margin, _y, {maxWidth: 190})
      _y += (pdf.getTextDimensions(list).h * lh_factor * 9 + th.mainPdfData.vspace)


      // date
      pdf.setFont('helvetica', 'normal', 'bold')
      pdf.setFontSize(size1)
      pdf.setTextColor(primary)

      lineHeight = th.px2mm(pdf.getLineHeight(date))
      _y += (th.mainPdfData.vspace + lineHeight)
      pdf.textAlign(date, {align: 'left'}, th.mainPdfData.x_half, _y)


      // sign
      let y2 = 0
      let signImg = null
      if (th.mainPdfData.sign?.src) {
        try {
          signImg = await th.downscaleImage(th.mainPdfData.sign.src, 150)
        } catch (e) {
          console.error('Failed to downscale signature:', e)
        }
      }
      y2 = _y - 7

      if (signImg) {
        try {
          const sign = th.imgSizes(th.mainPdfData.sign.w, th.mainPdfData.sign.h, 30)
          pdf.addImage(signImg, 'PNG', 35.5, y2, sign.w, sign.h)
        } catch (error) {
          console.error('Error adding signature to PDF:', error)
        }
      }

      _y += this.mainPdfData.vspace

      // sign label
      pdf.setFont('helvetica', 'normal', 'normal')
      pdf.setFontSize(size1)
      lineHeight = th.px2mm(pdf.getLineHeight(sing_title))
      _y += (lineHeight)
      pdf.textAlign(sing_title, {align: 'left'}, th.mainPdfData.page_margin, _y)

      pdf.textAlign(date_title, {align: 'left'}, th.mainPdfData.x_half, _y)

      _y += (th.mainPdfData.vspace - 2)
      // line
      pdf.setDrawColor(primary)
      pdf.line(th.mainPdfData.page_margin, _y, (th.mainPdfData.page_width - th.mainPdfData.page_margin), _y)


      // footer
      _y = 287
      pdf.setFont('helvetica', 'normal', 'normal')
      pdf.setFontSize(11)
      pdf.setTextColor('#7a7a7a')
      pdf.textAlign(th.mainPdfData.footer_content, {align: 'center'}, 0, _y)


      // let pdfOutput = btoa(pdf.output());

      let blobPDF = pdf.output('blob')

      if (!blobPDF || blobPDF.size === 0) {
        console.error('PDF generation failed. Blob is empty.')
        return
      }

      try {
        const arrayBuffer = await blobPDF.arrayBuffer()
        const pdfDoc = await PDFDocument.load(arrayBuffer)

        const compressedPdfBytes = await pdfDoc.save({
          useObjectStreams: true,
          compress: true,
        })

        const compressedBlob = new Blob([compressedPdfBytes], {type: 'application/pdf'})

        const formData = new FormData()
        formData.append('action', 'upload_pdf')
        formData.append('file', compressedBlob)

        $.ajax({
          url: window.admin.ajaxurl,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          xhr: function () {
            var xhr = new XMLHttpRequest()
            xhr.upload.addEventListener('progress', function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = (evt.loaded / evt.total) * 100
              }
            }, false)
            return xhr
          },
          success: function (data) {
            console.log('File uploaded successfully:', data)
            th.$emit('store_pdf_url', data)
          },
          error: function (xhr, status, error) {
            console.error('File upload failed:', error)
          }
        })
      } catch (err) {
        console.error('Compression or upload failed:', err)
      }
    },

  }
}
</script>
